import {
	faCircleCheck,
	faCircleExclamation,
	faCirclePause,
	faCirclePlay,
	faSpinner,
	IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";

import { CampaignDisplayStatus } from "@signalist/shared-types";

/**
 * Visual config per derived campaign status (PREC-3249). Colors use semantic Tailwind tokens;
 * FontAwesome Pro icons mirror the ticket's lucide names (AlertCircle/CheckCircle/Play/Pause).
 * Labels and tooltips come from i18n (`campaign.builder.status.*`).
 */
export const CAMPAIGN_STATUS_CONFIG: Record<
	CampaignDisplayStatus,
	{ icon: IconDefinition; iconClass: string }
> = {
	[CampaignDisplayStatus.INVALID]: { icon: faCircleExclamation, iconClass: "text-status-error" },
	[CampaignDisplayStatus.VALID]: { icon: faCircleCheck, iconClass: "text-blue-action" },
	[CampaignDisplayStatus.READY]: { icon: faCircleCheck, iconClass: "text-blue-action" },
	[CampaignDisplayStatus.ACTIVE]: { icon: faCirclePlay, iconClass: "text-status-success" },
	[CampaignDisplayStatus.PAUSED]: { icon: faCirclePause, iconClass: "text-status-warning" },
	[CampaignDisplayStatus.ENDED]: { icon: faCircleCheck, iconClass: "text-status-info" },
	[CampaignDisplayStatus.LOADING]: {
		icon: faSpinner,
		iconClass: "text-blue-action animate-spin",
	},
};
